import * as React from 'react'
import type { CSSProperties } from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import { cn } from '@/lib/utils'

export const TooltipProvider = TooltipPrimitive.Provider
export const Tooltip = TooltipPrimitive.Root
export const TooltipTrigger = TooltipPrimitive.Trigger

export const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, style, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    style={{ ...styles.content, ...style }}
    className={cn('tooltip-content', className)}
    {...props}
  />
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

const styles: Record<string, CSSProperties> = {
  content: {
    zIndex: 50,
    overflow: 'hidden',
    borderRadius: 'var(--radius-sm)',
    border: '1px solid var(--border-default)',
    background: 'var(--bg-secondary)',
    padding: '6px 12px',
    fontSize: '12px',
    color: 'var(--text-primary)',
    boxShadow: 'var(--shadow-md)',
  },
}
